/* @flow */
import {pick} from 'lodash';
import flattenMessages from '../utils/flattenMessages';
import type { Action } from './types';

export type FooterLink = {
  name: string,
  href: string
};

export type Newsletter = {
  channel: string,
  list: string,
  template: string
};

export type LocaleData = {
  messages: { [key: string]: string },
  locale: string,
  footerLinks: Array<FooterLink>,
  newsletters: Array<Newsletter>
};

export const LOAD_LOCALE = 'LOAD_LOCALE';
export const SET_GEOLOCATION = 'SET_GEOLOCATION';
export const SET_SHOULD_SHOW_GEOLOCATION_BANNER = 'SET_SHOULD_SHOW_GEOLOCATION_BANNER';

export const loadLocaleForEdition =
  (localeData: LocaleData): Action => ({
    type: LOAD_LOCALE,

    /*
     * Some keys in the locale config are not useful to
     * the React app. For example, `langTag` is pulled in
     * on the server side only.
     */
    ...pick(localeData, ['locale', 'newsletters', 'footerLinks']),

    messages: flattenMessages(localeData.messages)
  });

export const setGeolocation =
  (geolocation: string): Action => ({
    type: SET_GEOLOCATION,
    geolocation
  });

export const setShouldShowGeolocationBanner =
  (shouldShowGeolocationBanner: bool): Action => ({
    type: SET_SHOULD_SHOW_GEOLOCATION_BANNER,
    shouldShowGeolocationBanner
  });
